import type { SVGProps } from 'react'
const SvgSyRemove = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="M8 11.4v1.2h8v-1.2z" />
	</svg>
)
export default SvgSyRemove
